import React from 'react';

const styles = require('./ai_assist.module.scss');

interface Tab {
  id: string;
  label: string;
  isActive: boolean;
  isDisabled: boolean;
  badge?: string;
}

interface TabSelectorProps {
  activeTab: string;
  onTabChange: (tabId: string) => void;
}

export default function TabSelector({ activeTab, onTabChange }: TabSelectorProps) {
  const tabs: Tab[] = [
    { id: 'text', label: 'Add a text', isActive: activeTab === 'text', isDisabled: false },
    { id: 'file', label: 'Upload a file', isActive: activeTab === 'file', isDisabled: false },
    { id: 'link', label: 'Share a link', isActive: activeTab === 'link', isDisabled: true, badge: 'Soon' },
  ];

  return (
    <div className={styles.tabSelector}>
      {tabs.map((tab) => (
        <button
          key={tab.id}
          type="button"
          className={`${styles.tab} ${tab.isActive ? styles.tabActive : ''} ${
            tab.isDisabled ? styles.tabDisabled : ''
          }`}
          onClick={() => !tab.isDisabled && onTabChange(tab.id)}
          disabled={tab.isDisabled}
        >
          {tab.label}
          {tab.badge && <span className={styles.tabBadge}>{tab.badge}</span>}
        </button>
      ))}
    </div>
  );
}
